import { Controller } from "stimulus"

import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["medicine_name", "medicine_amount", "preset_input", "add_entry_button"]

  initialize() {
  }

  populate_preset() {
    if (this.preset_inputTarget.value == '') {
      return;
    }
    Rails.ajax({
      type: 'GET',
      url: '/prescription_presets/search?preset_name=' + this.preset_inputTarget.value,
      success: (result) => {
        var i = 0;
        this.medicine_nameTargets.forEach((el, j) => {
          if (el.value == '' && i < result.length) {
            el.value = result[i].medicine_name;
            this.medicine_amountTargets[j].value = result[i].amount;
            i++;
          }
        });
        for (; i < result.length; i++) {
          $(document).on('cocoon:after-insert', function (e, added_medicine) {
            added_medicine.find("[id$='_medicine_name']").val(result[i].medicine_name)
            added_medicine.find("[id$='_amount']").val(result[i].amount)
          })
          this.add_entry_buttonTarget.click();
        }
        this.preset_inputTarget.value = '';
      }
    })
  }

}